module.exports = __webpack_public_path__ + "img/2_2-industriale-centrale_elettrica-0.59d4d54e.png";